import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class PlatformDetectionService {
  private readonly platform: string;

  constructor() {
    this.platform = Capacitor.getPlatform();

    // Debug logging
    console.log('=== PlatformDetectionService Constructor ===');
    console.log('Capacitor.getPlatform():', this.platform);
    console.log('Capacitor.isNativePlatform():', Capacitor.isNativePlatform());
    console.log('User Agent:', navigator.userAgent);
    console.log('==========================================');
  }

  get isNative(): boolean {
    // Use Capacitor.isNativePlatform() as fallback if getPlatform() returns 'web'
    // This handles cases where the platform detection might be incorrect
    return this.platform !== 'web' || Capacitor.isNativePlatform();
  }

  get isWeb(): boolean {
    return this.platform === 'web' && !Capacitor.isNativePlatform();
  }

  get isIOS(): boolean {
    return this.platform === 'ios';
  }

  get isAndroid(): boolean {
    return this.platform === 'android';
  }

  getPlatform(): string {
    return this.platform;
  }
}

